export const downloadLink = (href: string) => {
	const link = document.createElement('a');
	link.href = href;
	link.setAttribute('download', '');
	link.hidden = true;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
